import React from 'react';

const Groupe = (props) => {
    return (
        <div className="region-statistics" >
            {props.items.map((item, j) =>
                (<div className='item ' key={j}>
                    <div className="value" style={{ backgroundColor: item.color}}>{item.value}</div>
                    <div className="label">{item.label}</div>
                </div>
                ))
            }
        </div>
    );
}

export default {
    Groupe
};